export const SUBSCRIBE_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    status: false,
    background_color: "#EF5A6F",
    title: "Subscribe to our newsletter for the latest updates and insights.",
    title_color: "#FFFFFF",
    description:
      "Stay ahead with the latest updates, insights, and events from Macat Megatrons.",
    description_color: "#FFFFFF",
    placeholder_text: "Enter your email",
    button_name: "Subscribe",
    button_background_color: "#BE2330",
    button_text_color: "#FFFFFF",
    button_icon: "",
    success_icon: "",
    success_text: "Thank you for subscribing!",
    success_text_color: "#FFFFFF",
  },

  SUBSCRIBE_FIELDS_CONFIG: [
    {
      fieldName: "status",
      label: "Subscribe Section Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Subscribe Section",
    },
    {
      fieldName: "background_color",
      label: "Background Color",
      value: "#EF5A6F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter background color (e.g., #EF5A6F)",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter title (e.g., Subscribe to our newsletter...)",
      required: true,
    },
    {
      fieldName: "title_color",
      label: "Title Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title color (e.g., #FFFFFF)",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder:
        "Enter description (e.g., Stay ahead with the latest updates...)",
    },
    {
      fieldName: "description_color",
      label: "Description Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter description color (e.g., #FFFFFF)",
    },
    {
      fieldName: "placeholder_text",
      label: "Input Placeholder Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter placeholder text (e.g., Enter your email)",
    },
    {
      fieldName: "button_name",
      label: "Button Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter button text (e.g., Subscribe)",
      required: true,
    },
    {
      fieldName: "button_background_color",
      label: "Button Background Color",
      value: "#BE2330",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button background color (e.g., #BE2330)",
    },
    {
      fieldName: "button_text_color",
      label: "Button Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter button text color (e.g., #FFFFFF)",
    },
    {
      fieldName: "button_icon",
      label: "Button Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Button Icon (optional)",
    },
    {
      fieldName: "button_icon_alt",
      label: "Button Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for button icon",
    },
    {
      fieldName: "success_icon",
      label: "Success Icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Success Icon (optional)",
    },
    {
      fieldName: "success_icon_alt",
      label: "Success Icon Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter alt text for success icon",
    },
    {
      fieldName: "success_text",
      label: "Success Message",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter success message (e.g., Thank you for subscribing!)",
      required: true,
    },
    {
      fieldName: "success_text_color",
      label: "Success Message Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter success message color (e.g., #FFFFFF)",
    },
  ],
};
